enum NotificationStatus {
  READ = 'read',
  UNREAD = 'unread',
  UNVIEWED = 'unviewed',
}

export default NotificationStatus;
